// Property Fee 物业费页面翻译
export default {
  // 页面标题
  'pages.property-fee.title': 'Property Fee',
  'pages.property-fee.subtitle': 'Management of property fee bill generation, payment and query',
  'pages.property-fee.currentSelection': 'Current selection:',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': 'Charge Management',
  'pages.breadcrumb.propertyFee': 'Property Fee',

  // 按钮
  'pages.property-fee.batchCreate': 'Batch Create',

  // 左侧树形选择
  'pages.property-fee.treeTitle': 'Building Floor House Selection',

  // 批量生成 Modal
  'pages.property-fee.batchModal.title': 'Batch Create Property Fee Bills',
  'pages.property-fee.batchModal.confirm': 'Confirm Generate',
  'pages.property-fee.batchModal.cancel': 'Cancel',
  'pages.property-fee.batchModal.periodLabel': 'Select Period:',
  'pages.property-fee.batchModal.periodPlaceholder': 'Please select period',
  'pages.property-fee.batchModal.confirmTitle': 'Confirm Batch Generate',
  'pages.property-fee.batchModal.confirmContent': 'Are you sure to batch generate property fee bills for {period}?',
  'pages.property-fee.batchModal.success': 'Successfully generated {count} bills',
  'pages.property-fee.batchModal.error': 'Batch generation failed',
  'pages.property-fee.batchModal.selectPeriodWarning': 'Please select period',

  // 提示信息
  'pages.property-fee.batchModal.hint': '💡 Hint: Batch generation will create property fee bills for all houses without bills for the specified period',
  'pages.property-fee.batchModal.hint2': 'Existing bills will not be generated again',

  // PropertyFeeTable 表格
  'pages.property-fee.table.title': 'Property Fee Bills List',

  // 表格列标题
  'pages.property-fee.table.columns.houseNumber': 'House Number',
  'pages.property-fee.table.columns.buildingName': 'Building',
  'pages.property-fee.table.columns.floorName': 'Floor',
  'pages.property-fee.table.columns.ownerName': 'Owner Name',
  'pages.property-fee.table.columns.ownerPhone': 'Owner Phone',
  'pages.property-fee.table.columns.ownerIdCard': 'Owner ID Card',
  'pages.property-fee.table.columns.ownerEmail': 'Owner Email',
  'pages.property-fee.table.columns.period': 'Period',
  'pages.property-fee.table.columns.billNo': 'Bill Number',
  'pages.property-fee.table.columns.propertyFee': 'Property Fee',
  'pages.property-fee.table.columns.maintenanceFee': 'Maintenance Fee',
  'pages.property-fee.table.columns.otherFee': 'Other Fee',
  'pages.property-fee.table.columns.totalAmount': 'Total Amount',
  'pages.property-fee.table.columns.paymentAmount': 'Payment Amount',
  'pages.property-fee.table.columns.paymentTime': 'Payment Time',
  'pages.property-fee.table.columns.dueAmount': 'Due',
  'pages.property-fee.table.columns.actualAmount': 'Paid',
  'pages.property-fee.table.columns.finalAmount': 'Final Amount',
  'pages.property-fee.table.columns.status': 'Payment Status',
  'pages.property-fee.table.columns.approvalStatus': 'Approval Status',
  'pages.property-fee.table.columns.paymentDate': 'Payment Date',
  'pages.property-fee.table.columns.dueDate': 'Due Date',
  'pages.property-fee.table.columns.operations': 'Operations',

  // 操作按钮
  'pages.property-fee.table.actions.view': 'View',
  'pages.property-fee.table.actions.edit': 'Edit',
  'pages.property-fee.table.actions.delete': 'Delete',
  'pages.property-fee.table.actions.cancel': 'Cancel',
  'pages.property-fee.table.actions.submitAudit': 'Submit Audit',
  'pages.property-fee.table.actions.batchDelete': 'Batch Delete',
  'pages.property-fee.table.actions.createBill': 'Create Bill',

  // 状态选项
  'pages.property-fee.status.unpaid': 'Unpaid',
  'pages.property-fee.status.paid': 'Paid',
  'pages.property-fee.status.overdue': 'Overdue',
  'pages.property-fee.status.partial': 'Partial',
  'pages.property-fee.status.cancelled': 'Cancelled',

  // 审核状态
  'pages.property-fee.approvalStatus.draft': 'Draft',
  'pages.property-fee.approvalStatus.pending': 'Pending',
  'pages.property-fee.approvalStatus.approved': 'Approved',
  'pages.property-fee.approvalStatus.rejected': 'Rejected',
  'pages.property-fee.approvalStatus.notified': 'Notified',
  'pages.property-fee.approvalStatus.overdue': 'Overdue',
  'pages.property-fee.approvalStatus.cancelled': 'Cancelled',

  // 账单周期
  'pages.property-fee.billingCycle.monthly': 'Monthly',
  'pages.property-fee.billingCycle.quarterly': 'Quarterly',
  'pages.property-fee.billingCycle.semi_annual': 'Semi-annual',
  'pages.property-fee.billingCycle.yearly': 'Yearly',

  // 删除确认
  'pages.property-fee.table.delete.confirm.title': 'Confirm Delete',
  'pages.property-fee.table.delete.confirm.content': 'Are you sure you want to delete this property fee bill? This action cannot be undone.',
  'pages.property-fee.table.delete.success': 'Delete successful',
  'pages.property-fee.table.delete.error': 'Delete failed',

  // 批量删除
  'pages.property-fee.table.batchDelete.confirm.title': 'Confirm Batch Delete',
  'pages.property-fee.table.batchDelete.confirm.content': 'Are you sure you want to delete the selected {count} property fee bills? This action cannot be undone.',
  'pages.property-fee.table.batchDelete.confirm.contentSimple': 'Are you sure you want to delete the selected {count} records?',
  'pages.property-fee.table.batchDelete.success': 'Batch delete successful',
  'pages.property-fee.table.batchDelete.error': 'Batch delete failed',
  'pages.property-fee.table.batchDelete.noSelection': 'Please select bills to delete first',
  'pages.property-fee.table.batchDelete.draftOnly': 'Only draft bills can be deleted in batches',

  // 提交审核
  'pages.property-fee.table.auditModal.title': 'Submit for Audit',
  'pages.property-fee.table.auditModal.submit': 'Submit for Audit',
  'pages.property-fee.table.auditModal.auditName': 'Audit Name',
  'pages.property-fee.table.auditModal.submitRemark': 'Submission Notes',
  'pages.property-fee.table.auditModal.auditNamePlaceholder': 'Please enter audit name',
  'pages.property-fee.table.auditModal.submitRemarkPlaceholder': 'Please enter submission notes (optional)',
  'pages.property-fee.table.auditModal.auditNameRequired': 'Please enter audit name',
  'pages.property-fee.table.auditModal.submitRemarkRequired': 'Please enter submission notes',
  'pages.property-fee.table.auditModal.success': 'Submit for audit successful',
  'pages.property-fee.table.auditModal.error': 'Submit for audit failed',
  'pages.property-fee.table.auditModal.noSelection': 'Please select bills to submit for audit first',
  'pages.property-fee.table.auditModal.selectedBills': 'Selected bills list ({count} items)',

  // 审核表格列标题
  'pages.property-fee.table.auditModal.columns.billNo': 'Bill Number',
  'pages.property-fee.table.auditModal.columns.houseNumber': 'House Number',
  'pages.property-fee.table.auditModal.columns.period': 'Period',
  'pages.property-fee.table.auditModal.columns.totalAmount': 'Total Amount',
  'pages.property-fee.table.auditModal.columns.status': 'Payment Status',

  // 详情弹窗
  'pages.property-fee.table.detail.title': 'Property Fee Bill Details',
  'pages.property-fee.table.detail.close': 'Close',

  // 详情区块标题
  'pages.property-fee.table.detail.basicInfo': 'Basic Information',
  'pages.property-fee.table.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.property-fee.table.detail.feeInfo': 'Fee Information',
  'pages.property-fee.table.detail.paymentInfo': 'Payment Information',
  'pages.property-fee.table.detail.systemInfo': 'System Information',
  'pages.property-fee.table.detail.auditRecords': 'Audit Records',

  // 详情字段标签
  'pages.property-fee.table.detail.labels.billNo': 'Bill Number',
  'pages.property-fee.table.detail.labels.period': 'Period',
  'pages.property-fee.table.detail.labels.status': 'Payment Status',
  'pages.property-fee.table.detail.labels.approvalStatus': 'Approval Status',
  'pages.property-fee.table.detail.labels.startDate': 'Start Date',
  'pages.property-fee.table.detail.labels.endDate': 'End Date',
  'pages.property-fee.table.detail.labels.houseInfo': 'House Information',
  'pages.property-fee.table.detail.labels.ownerInfo': 'Owner Information',
  'pages.property-fee.table.detail.labels.propertyFee': 'Property Fee',
  'pages.property-fee.table.detail.labels.maintenanceFee': 'Maintenance Fund',
  'pages.property-fee.table.detail.labels.otherFee': 'Other Fees',
  'pages.property-fee.table.detail.labels.lateFee': 'Late Fee',
  'pages.property-fee.table.detail.labels.discountAmount': 'Discount Amount',
  'pages.property-fee.table.detail.labels.finalAmount': 'Final Amount',
  'pages.property-fee.table.detail.labels.paymentMethod': 'Payment Method',
  'pages.property-fee.table.detail.labels.paymentReference': 'Payment Reference',
  'pages.property-fee.table.detail.labels.dueDate': 'Due Date',
  'pages.property-fee.table.detail.labels.paymentDate': 'Payment Date',
  'pages.property-fee.table.detail.labels.createTime': 'Create Time',
  'pages.property-fee.table.detail.labels.updateTime': 'Update Time',
  'pages.property-fee.table.detail.labels.remark': 'Remark',
  'pages.property-fee.table.detail.labels.ownerId': 'Owner ID',
  'pages.property-fee.table.detail.labels.idCard': 'ID Card',
  'pages.property-fee.table.detail.labels.email': 'Email',

  // PropertyFeeForm 表单
  'pages.property-fee.form.editTitle': 'Edit Property Fee Bill',
  'pages.property-fee.form.createTitle': 'Create Property Fee Bill',
  'pages.property-fee.form.basicInfo': 'Basic Information',
  'pages.property-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.property-fee.form.feeInfo': 'Fee Information',
  'pages.property-fee.form.remarks': 'Remarks',
  'pages.property-fee.form.submit': 'Submit',
  'pages.property-fee.form.reset': 'Reset',

  // 表单字段标签
  'pages.property-fee.form.fields.billNo': 'Bill Number',
  'pages.property-fee.form.fields.status': 'Payment Status',
  'pages.property-fee.form.fields.period': 'Period',
  'pages.property-fee.form.fields.startDate': 'Start Date',
  'pages.property-fee.form.fields.endDate': 'End Date',
  'pages.property-fee.form.fields.building': 'Building',
  'pages.property-fee.form.fields.floor': 'Floor',
  'pages.property-fee.form.fields.house': 'House',
  'pages.property-fee.form.fields.ownerName': 'Owner Name',
  'pages.property-fee.form.fields.ownerPhone': 'Owner Phone',
  'pages.property-fee.form.fields.ownerIdCard': 'Owner ID Card',
  'pages.property-fee.form.fields.ownerEmail': 'Owner Email',
  'pages.property-fee.form.fields.propertyFee': 'Basic Property Fee',
  'pages.property-fee.form.fields.maintenanceFee': 'Maintenance Fund',
  'pages.property-fee.form.fields.otherFee': 'Other Fees',
  'pages.property-fee.form.fields.lateFee': 'Late Fee',
  'pages.property-fee.form.fields.discountAmount': 'Discount Amount',
  'pages.property-fee.form.fields.finalAmount': 'Final Amount',
  'pages.property-fee.form.fields.remark': 'Remark',

  // 表单占位符
  'pages.property-fee.form.placeholder.period': 'E.g.: 2024-01',
  'pages.property-fee.form.placeholder.startDate': 'Please select start date',
  'pages.property-fee.form.placeholder.endDate': 'Please select end date',
  'pages.property-fee.form.placeholder.building': 'Please select building',
  'pages.property-fee.form.placeholder.floor': 'Please select floor',
  'pages.property-fee.form.placeholder.house': 'Please select house',
  'pages.property-fee.form.placeholder.ownerName': 'Please enter owner name',
  'pages.property-fee.form.placeholder.ownerPhone': 'Please enter owner phone',
  'pages.property-fee.form.placeholder.ownerIdCard': 'Please enter owner ID card',
  'pages.property-fee.form.placeholder.ownerEmail': 'Please enter owner email',
  'pages.property-fee.form.placeholder.propertyFee': 'Please enter property fee amount',
  'pages.property-fee.form.placeholder.maintenanceFee': 'Please enter maintenance fee amount',
  'pages.property-fee.form.placeholder.otherFee': 'Please enter other fee',
  'pages.property-fee.form.placeholder.discountAmount': 'Please enter discount amount',
  'pages.property-fee.form.placeholder.finalAmount': 'Please enter final amount',
  'pages.property-fee.form.placeholder.remark': 'Please enter remark',

  // 表单验证消息
  'pages.property-fee.form.validation.periodRequired': 'Please enter period',
  'pages.property-fee.form.validation.startDateRequired': 'Please select start date',
  'pages.property-fee.form.validation.endDateRequired': 'Please select end date',
  'pages.property-fee.form.validation.buildingRequired': 'Please select building',
  'pages.property-fee.form.validation.floorRequired': 'Please select floor',
  'pages.property-fee.form.validation.houseRequired': 'Please select house',
  'pages.property-fee.form.validation.propertyFeeRequired': 'Please enter basic property fee',
  'pages.property-fee.form.validation.finalAmountRequired': 'Total amount will be calculated automatically',
  'pages.property-fee.form.validation.remarkMaxLength': 'Remark length cannot exceed 500 characters',
  'pages.property-fee.form.validation.loadPriceConfigFailed': 'Load price config failed',
  'pages.property-fee.form.validation.loadHouseInfoFailed': 'Load house info failed',

  // 表单提交消息
  'pages.property-fee.form.submit.success': 'Property fee bill saved successfully',
  'pages.property-fee.form.submit.error': 'Save failed, please try again',

  // 货币单位
  'pages.property-fee.currency.php': '₱',

  // HouseSelector House Selector
  'pages.property-fee.houseSelector.title': 'Select House',
  'pages.property-fee.houseSelector.confirm': 'Confirm Select',
  'pages.property-fee.houseSelector.cancel': 'Cancel',
  'pages.property-fee.houseSelector.selectHouseWarning': 'Please select a house',
  'pages.property-fee.houseSelector.treeTitle': 'Building Floor Selection',
  'pages.property-fee.houseSelector.tableTitle': 'House List',

  // House List Table Columns
  'pages.property-fee.houseSelector.columns.select': 'Select',
  'pages.property-fee.houseSelector.columns.floor': 'Floor',
  'pages.property-fee.houseSelector.columns.houseNumber': 'House Number',
  'pages.property-fee.houseSelector.columns.ownerName': 'Owner Name',
  'pages.property-fee.houseSelector.columns.ownerPhone': 'Owner Phone',

  // Pagination Info
  'pages.property-fee.table.pagination.showTotal': 'Items {start}-{end} of {total}',

  // Audit Records
  'pages.property-fee.table.detail.audit.loading': 'Loading...',
  'pages.property-fee.table.detail.audit.noRecords': 'No audit records',

  // Audit Name Template
  'pages.property-fee.table.auditModal.defaultNameTemplate': '{period} Property Fee Bills ({count} items)',

  // Detail Labels
  'pages.property-fee.table.detail.labels.idCardPrefix': 'ID Card:',
  'pages.property-fee.table.detail.labels.emailPrefix': 'Email:',
  'pages.property-fee.table.detail.labels.ownerIdPrefix': 'Owner ID:',
};
